var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('h2',[_vm._v(_vm._s(_vm.$t("deposit.add.header")))]),_c('DepositAdd',{on:{"submit":function($event){return _vm.submit()},"close":_vm.close}}),(_vm.submitView)?_c('vca-popup',{attrs:{"show":_vm.submitView,"title":"Popup"},on:{"close":_vm.close}},[_c('DepositSubmit',{ref:"donation_submit",on:{"close":_vm.close}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }